/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  BalanceShifter,
  BalanceShifterInterface,
} from "../BalanceShifter";

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "shift",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class BalanceShifter__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BalanceShifter> {
    return super.deploy(overrides || {}) as Promise<BalanceShifter>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BalanceShifter {
    return super.attach(address) as BalanceShifter;
  }
  connect(signer: Signer): BalanceShifter__factory {
    return super.connect(signer) as BalanceShifter__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BalanceShifterInterface {
    return new utils.Interface(_abi) as BalanceShifterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BalanceShifter {
    return new Contract(address, _abi, signerOrProvider) as BalanceShifter;
  }
}
